module.exports = __webpack_public_path__ + "img/cards-safe.0a2637dd.svg";